module.exports = __webpack_public_path__ + "557df9e307b7fcf838332994632ecc87.png";